import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/KellyCogan_Life/subs.vtt';
import poster from '@/static/assets/reviews/KellyCogan_Life/video.jpg';

export const KellyCogan: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Life],
  reviewerName: 'Kelly',
  videoUrl: `${ASSETS_URL}/life/KellyCogan_Life.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
